import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "select", "customerId", "customerName", "title", "city", "zip"]
  static values = { url: String, geocodeUrl: String }

  async lookupZip() {
    const zip = this.zipTarget.value.trim()
    if (zip.length < 4 || !this.hasGeocodeUrlValue) return
    try {
      const response = await fetch(`${this.geocodeUrlValue}?zip=${encodeURIComponent(zip)}`, { headers: { "Accept": "application/json" } })
      if (!response.ok) return
      const data = await response.json()
      if (data.city && this.hasCityTarget && !this.cityTarget.value) this.cityTarget.value = data.city
    } catch (e) {
      // Geocoding ist optional — Fehler still ignorieren
    }
  }

  open(event) {
    if (event) event.preventDefault()
    const customer = this.element.closest("form")?.querySelector('select[name*="[customer_id]"]')
    let id = "", name = ""
    if (customer) {
      id = customer.tomselect ? customer.tomselect.getValue() : customer.value
      name = customer.selectedOptions && customer.selectedOptions[0] ? customer.selectedOptions[0].text : ""
    }
    if (this.hasCustomerIdTarget) this.customerIdTarget.value = id
    if (this.hasCustomerNameTarget) this.customerNameTarget.textContent = id ? name : "— kein Kunde in der Anfrage gewählt —"
    this.panelTarget.classList.remove("hidden")
    if (this.hasTitleTarget) this.titleTarget.focus()
  }

  close(event) {
    if (event) event.preventDefault()
    this.panelTarget.classList.add("hidden")
  }

  async save(event) {
    if (event) event.preventDefault()
    if (!this.hasCustomerIdTarget || !this.customerIdTarget.value) {
      window.alert("Bitte zuerst in der Anfrage einen Kunden wählen – der Kundenstandort wird diesem Kunden zugeordnet.")
      return
    }
    const body = new FormData()
    body.append("customer_location[title]", this.titleTarget.value)
    body.append("customer_location[city]", this.cityTarget.value)
    body.append("customer_location[zip]", this.zipTarget.value)
    if (this.hasCustomerIdTarget) body.append("customer_location[customer_id]", this.customerIdTarget.value)
    body.append("customer_location[published]", "1")

    const token = document.querySelector('meta[name="csrf-token"]')
    const response = await fetch(`${this.urlValue}.json`, {
      method: "POST",
      headers: { "X-CSRF-Token": token ? token.content : "", "Accept": "application/json" },
      body
    })

    if (response.ok) {
      const data = await response.json()
      const option = new Option(data.title, data.id, true, true)
      this.selectTarget.add(option)
      this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
      this.titleTarget.value = ""
      this.cityTarget.value = ""
      this.zipTarget.value = ""
      this.close()
    } else {
      window.alert("Kundenstandort konnte nicht angelegt werden. Titel und Stadt sind Pflichtfelder.")
    }
  }
}
